export default function getRelativeDate(daysOffset: number): string {
  const date = new Date(new Date().setDate(new Date().getDate() + daysOffset));
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
